/* Decorative SVG components inspired by the Shree Event Planner logo —
   ornamental gold filigree, paisley swirls, divider stars. */

export function FiligreeFlourish({ className = "", flip = false }) {
  return (
    <svg
      viewBox="0 0 400 80"
      className={className}
      style={flip ? { transform: "scaleX(-1)" } : undefined}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <defs>
        <linearGradient id="filGold" x1="0" x2="1" y1="0" y2="0">
          <stop offset="0%" stopColor="#8E6B1A" stopOpacity="0.1" />
          <stop offset="50%" stopColor="#E8C46A" />
          <stop offset="100%" stopColor="#8E6B1A" stopOpacity="0.1" />
        </linearGradient>
      </defs>
      <g stroke="url(#filGold)" strokeWidth="1.2" strokeLinecap="round" fill="none">
        <path d="M10 40 C 60 10, 100 70, 160 40 S 240 10, 300 40 S 380 60, 395 40" />
        <path d="M70 38 C 80 25, 95 25, 110 38" opacity="0.85" />
        <path d="M150 42 C 165 55, 185 55, 200 42" opacity="0.85" />
        <path d="M230 38 C 245 25, 265 25, 280 38" opacity="0.85" />
        <circle cx="40" cy="40" r="1.5" fill="#E8C46A" />
        <circle cx="200" cy="40" r="2" fill="#E8C46A" />
        <circle cx="360" cy="40" r="1.5" fill="#E8C46A" />
        <path d="M195 30 L 200 25 L 205 30 L 200 40 Z" fill="#E8C46A" opacity="0.7" />
      </g>
    </svg>
  );
}

export function CornerOrnament({ className = "", rotate = 0 }) {
  return (
    <svg
      viewBox="0 0 200 200"
      className={className}
      style={{ transform: `rotate(${rotate}deg)` }}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <g stroke="#D4AF37" strokeWidth="1" fill="none" opacity="0.75">
        <path d="M10 10 C 50 30, 60 80, 30 110" />
        <path d="M10 10 C 35 18, 55 35, 70 60" />
        <path d="M10 10 L 70 60" opacity="0" />
        <path d="M30 110 C 45 95, 60 100, 75 115 S 95 130, 80 145" />
        <circle cx="75" cy="115" r="2" fill="#E8C46A" />
        <circle cx="30" cy="110" r="2" fill="#E8C46A" />
        <path d="M55 35 C 65 28, 78 28, 88 35 S 100 50, 90 60" />
        <path d="M14 14 c 4 -2 8 -1 10 2 c 2 3 1 7 -2 9" />
      </g>
    </svg>
  );
}

export function Paisley({ className = "", color = "#D4AF37" }) {
  return (
    <svg
      viewBox="0 0 80 120"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <g stroke={color} strokeWidth="1" fill="none" opacity="0.7">
        <path d="M40 110 C 10 90, 5 50, 40 20 C 70 30, 75 70, 50 95 C 40 102, 35 100, 38 90 C 42 75, 55 65, 55 50 C 55 38, 45 33, 38 40" />
        <circle cx="40" cy="40" r="2" fill={color} />
        <circle cx="38" cy="55" r="1" fill={color} opacity="0.6" />
        <circle cx="42" cy="70" r="1" fill={color} opacity="0.6" />
        <path d="M40 20 C 35 12, 30 8, 25 10" />
      </g>
    </svg>
  );
}

export function DividerStar({ className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-3 ${className}`} aria-hidden>
      <span className="h-px w-12 bg-gradient-to-r from-transparent to-gold/70" />
      <svg viewBox="0 0 30 30" className="w-5 h-5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g stroke="#D4AF37" fill="none">
          <path d="M15 2 L 17 13 L 28 15 L 17 17 L 15 28 L 13 17 L 2 15 L 13 13 Z" fill="#D4AF37" opacity="0.85" />
        </g>
      </svg>
      <span className="h-px w-12 bg-gradient-to-l from-transparent to-gold/70" />
    </div>
  );
}

export function Mandala({ className = "" }) {
  return (
    <svg
      viewBox="0 0 300 300"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <g stroke="#D4AF37" strokeWidth="0.8" fill="none" opacity="0.5">
        <circle cx="150" cy="150" r="40" />
        <circle cx="150" cy="150" r="65" strokeDasharray="3 4" />
        <circle cx="150" cy="150" r="95" />
        <circle cx="150" cy="150" r="120" strokeDasharray="2 6" />
        {[...Array(12)].map((_, i) => {
          const angle = (i * 30 * Math.PI) / 180;
          const x1 = 150 + Math.cos(angle) * 40;
          const y1 = 150 + Math.sin(angle) * 40;
          const x2 = 150 + Math.cos(angle) * 95;
          const y2 = 150 + Math.sin(angle) * 95;
          return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} />;
        })}
        {[...Array(8)].map((_, i) => {
          const angle = (i * 45 * Math.PI) / 180;
          const cx = 150 + Math.cos(angle) * 110;
          const cy = 150 + Math.sin(angle) * 110;
          return <circle key={i} cx={cx} cy={cy} r="3" fill="#D4AF37" />;
        })}
      </g>
    </svg>
  );
}
